import CarregamentoComponentes from "@/Components/Base/Carregamento";
import ComponentePermissao from "@/Components/Base/Permissao/ComponentePermissao";
import InscricaoDesconto, { EnumTipoValor } from "@/Models/Domain/Viagem/Inscricao/InscricaoDesconto";
import Pagina, { IPaginaInfo, PaginaInfo } from "@/Models/Utils/Pagina/Pagina";
import { useInscricaoDescontoListarPagina } from "@/Services/Domain/Viagem/Inscricao/InscricaoDescontoService";
import { Button, Col, Divider, Empty, Form, FormProps, Row } from "antd";
import { useState } from "react";
import { Link } from "react-router-dom";
import InscricaoDescontoTableBasic, { IInscricaoDescontoTableBasicProps } from "./InscricaoDescontoTableBasic";
import ViagemSelect from "../../ViagemSelect";

export interface IInscricaoDescontoConsultaFormType {
    pagina:IPaginaInfo,
    inscricaoDesconto?:InscricaoDesconto|null,
    codTipoValor?:EnumTipoValor,
    ativo?:boolean|null
}

export interface IInscricaoDescontoConsultaScreenProps extends FormProps<IInscricaoDescontoConsultaFormType> {
    tableProps?:Omit<IInscricaoDescontoTableBasicProps, "dataSource">;
}

export default function InscricaoDescontoConsultaScreen({
    form : formParam,
    initialValues,
    tableProps,
    component,
    layout,
    ...rest
}:IInscricaoDescontoConsultaScreenProps) {
    const [newForm] = Form.useForm<IInscricaoDescontoConsultaFormType>();
    const form = formParam ?? newForm;
    const inputRequest = Form.useWatch([], form);
    const [ consultar, setConsultar ] = useState(true);

    const {
        data,
        isLoading,
        isSuccess,
        isError,
        refetch
    } = useInscricaoDescontoListarPagina({
        ...inputRequest,
        pagina : inputRequest?.pagina ?? new Pagina(),
        enabled : consultar,
        onFinish() {
            setConsultar(false);
        }
    });

    return <Form
        {...rest}
        form={form}
        component={component === undefined ? "div" : component}
        layout={layout === undefined ? "vertical" : layout}
        initialValues={{
            ...initialValues,
            pagina : initialValues?.pagina === undefined ? new PaginaInfo() : initialValues?.pagina,
            inscricaoDesconto : initialValues?.inscricaoDesconto === undefined ? {} as InscricaoDesconto : initialValues?.inscricaoDesconto,
            codTipoValor : initialValues?.codTipoValor === undefined ? null : initialValues.codTipoValor,
            ativo : initialValues?.ativo === undefined ? true : initialValues.ativo,
            entrada: undefined
        }}
        onFinish={() => {
            form.setFieldsValue({
                pagina : {
                    pagina : 1
                }
            } as any);
            setConsultar(true);
        }}
    >
        <Row gutter={8} wrap>
            <Form.Item<IInscricaoDescontoConsultaFormType> hidden name={["pagina"]}></Form.Item>
            <Form.Item<IInscricaoDescontoConsultaFormType> hidden name={["codTipoValor"]}></Form.Item>
            <Form.Item<IInscricaoDescontoConsultaFormType> hidden name={["ativo"]}></Form.Item>
            <Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={6}>
                <Form.Item<IInscricaoDescontoConsultaFormType> 
                    name={["inscricaoDesconto", "codViagem"]}
                    label="Viagem"
                >
                    <ViagemSelect />
                </Form.Item>
            </Col>
        </Row>

        <Row gutter={8} wrap>
            <ComponentePermissao permissoes={["FinanceiroContaMovimentacaoListarTodos"]}>
                <Col xs={"auto"}>
                    <Button type="primary" loading={isLoading} onClick={() => form.submit()}>
                        Listar
                    </Button>
                </Col>
            </ComponentePermissao>
            <ComponentePermissao permissoes={["FinanceiroContaMovimentacaoInserir"]}>
                <Col xs={"auto"}>
                    <Link to={"Novo"}>
                        <Button type="primary">Adicionar</Button>
                    </Link>
                </Col>
            </ComponentePermissao>
        </Row> 
        {
            (isSuccess || isLoading) && <>
                <Divider>Registros</Divider>
                <ComponentePermissao permissoes={["FinanceiroContaMovimentacaoListarTodos"]}>
                    <CarregamentoComponentes.TelaCarregamento ativo={isLoading || !!tableProps?.loading}>
                        <InscricaoDescontoTableBasic 
                            {...tableProps} 
                            dataSource={data}
                            onSuccess={() => {
                                refetch();
                            }}
                            onChange={(pagina, ...restParam) => {
                                form.setFieldsValue({
                                    pagina : {
                                        pagina : pagina.current ?? 1,
                                        tamanho : pagina.pageSize ?? 15
                                    }
                                } as any);

                                setConsultar(true);
                            }} 
                        />
                    </CarregamentoComponentes.TelaCarregamento>
                </ComponentePermissao>
            </> || <>
                <Empty description={isError ? "Ocorreu um erro, tente novamente!" : "Clique em \"Listar\" para realizar a consulta."} />
            </>
        }
    </Form>;
}